
<div class="select-input">
  <dropdown
    flex
    :align="align"
    :active="active"
    @close="active = false"
  >
    <div
      :class="['input', { disabled, active, searchable }]"
      tabindex="0"
      @focus="onTabFocus"
    >
      <label :for="id">{{ label }}</label>

      <div class="value">{{ selectedLabel }}</div>

      <input
        ref="input"
        v-model="searchString"
        :disabled="disableSearch"
        @blur.stop.prevent="onInputBlur"
        @keydown="navigateItems"
      />

      <icon
        class="arrow"
        :name="active ? 'expand_less' : 'expand_more'"
      />
    </div>

    <template #menu>
      <dropdown-menu
        :options="filteredOptions"
        :activeValue="selectedValue"
        :focus="itemFocus"
        @select="handleSelect"
        @mouseenter="mouseover = 'menu'"
        @mouseleave="mouseover = ''"
      />
    </template>
  </dropdown>
</div>
